import { MenuPlat } from "./MenuPlat";

class Menu {
    constructor(
        public id: number = 0,
        public setmana: string = "",
        public id_variacio: number = 0,
        public basal: number = 0,
        public plats: Array<MenuPlat> = [],
    ){
    }
}
export {Menu};